import { LoadingOverlay } from '@/components/ui/Loaders'
import * as React from 'react'
import { useAuth } from '@/features/auth'
import { useTranslation } from 'react-i18next'
import './auth-layout.scss'
import { ErrorBoundary } from 'react-error-boundary'

type AuthLayoutProps = {
  title: string
  content: React.ReactElement
  footer?: React.ReactElement
}

export const AuthLayout = ({ content, footer }: AuthLayoutProps) => {
  const { t } = useTranslation()
  const auth = useAuth()
  if (!auth.initialized) {
    return <LoadingOverlay />
  }

  if (auth.isLoggedIn()) {
    return (
      <div className="auth-layout">
        <div className="auth-layout__content">
          <div className="knots-form">
            <h2 style={{ marginBottom: '25px' }}>{t('auth.leavingAlready')}</h2>
            <button className="btn" onClick={auth.logout}>
              {t('auth.logout')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <ErrorBoundary fallback={<div>Form error</div>}>
      <div className="auth-layout">
        <div className="auth-layout__content">
          <div className="knots-form">{content}</div>
        </div>
        <div className="auth-layout__footer">
          <div className="knots-form">{footer}</div>
        </div>
      </div>
    </ErrorBoundary>
  )
}
